import app from 'flarum/common/app';

app.initializers.add('nodeloc/nl-patchs', () => {
  console.log('[nodeloc/nl-patchs] Hello, forum and admin!');
});
